import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';

import { ModuleWithProviders } from '@angular/core';

import { AuthGuard } from './services/auth-guard.service';
import { LoginComponent } from './auth/login/login.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { ConfirmOrderComponent } from './confirm-order/confirm-order.component';
import { DeepLinkComponent } from './deep-link/deep-link.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { LandingComponent } from './landing/landing.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';

export const appRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'delete-my-account',
    component: DeleteAccountComponent,
  },
  {
    path: 'forgot-password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'forgot-password/reset/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'admin/forgot-password/reset/:admin_token',
    component: ResetPasswordComponent,
  },
  {
    path: '',
    loadChildren: 'app/theme/theme.module#ThemeModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'confirm-order/:id/:token',
    component: ConfirmOrderComponent
  },
  {
    path: 'download',
    component: DeepLinkComponent
  },
  {
    path: 'privacy',
    component: PrivacyComponent,
  },
  {
    path: 'home',
    component: LandingComponent
  }
  // {
  //   path: '**',
  //   redirectTo: 'login',
  //   pathMatch: 'full'
  // }
];

@NgModule({
  imports: [ RouterModule.forRoot(appRoutes, { useHash: true}),HttpModule ],
  exports: [ RouterModule,HttpModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/app-routing.ts